module.exports = __webpack_public_path__ + "static/media/TrainingAndDevelopment-banner.5c3284c5.jpg";